import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFileArchive,
  faFileCode,
  faFilePdf,
  faFile,
  faFileAlt,
  faCopy,
  faClipboard,
  faBuilding,
  faUser,
  faPaperPlane,
  faIdCard,
  faCreditCard,
  faChartBar,
  faCheckSquare,
  faCircle,
  faEdit,
  faListAlt,
  faDotCircle,
  faClone,
  faAddressBook,
} from '@fortawesome/free-regular-svg-icons';

import {
  faBars,
  faCheck,
  faCheckCircle,
  faCircle as fasCircle,
  faHome,
  faClock,
  faStopwatch,
  faFileExport,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faArrowLeft,
  faArrowRight,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faExchangeAlt,
  faSync,
  faSyncAlt,
  faTachometerAlt,
  faUsers,
  faCubes,
  faRocket,
  faCog,
  faCode,
  faShoppingBasket,
  faSearch,
  faTimes,
  faIndent,
  faBell,
  faTasks,
  faFilter,
  faSlidersH,
  faCheckDouble,
  faList,
  faBoxes,
  faBoxOpen,
  faWeightHanging,
  faChartLine,
  faShieldAlt,
  faIndustry,
  faCloudUploadAlt,
  faFileImport,
  faTrash,
  faFileInvoice,
  faFileExcel,
  faFileAlt as fasFileAlt,
  faUpload,
  faUserShield,
  faDownload,
  faEnvelope,
  faEye,
  faEyeSlash,
  faCogs,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faFileExcel,
  faBars,
  faFileArchive,
  faFileCode,
  faFilePdf,
  faFile,
  faFileAlt,
  faCopy,
  faClipboard,
  faBuilding,
  faUser,
  faPaperPlane,
  faIdCard,
  faCreditCard,
  faChartBar,
  faCheckSquare,
  faCircle,
  faCheck,
  faCheckCircle,
  fasCircle,
  faHome,
  faClock,
  faStopwatch,
  faFileExport,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faArrowLeft,
  faArrowRight,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faExchangeAlt,
  faSync,
  faSyncAlt,
  faTachometerAlt,
  faUsers,
  faCubes,
  faRocket,
  faCog,
  faCogs,
  faCode,
  faShoppingBasket,
  faSearch,
  faTimes,
  faIndent,
  faBell,
  faCircle,
  faTasks,
  faFilter,
  faSlidersH,
  faCheckDouble,
  faList,
  faBoxes,
  faBoxOpen,
  faWeightHanging,
  faChartLine,
  faShieldAlt,
  faIndustry,
  faCloudUploadAlt,
  faFileImport,
  faEdit,
  faListAlt,
  faDotCircle,
  faClone,
  faAddressBook,
  faTrash,
  faFileInvoice,
  fasFileAlt,
  faUpload,
  faUserShield,
  faDownload,
  faEnvelope,
  faEye,
  faEyeSlash,
);